import {FC} from 'react';
import {JsonView, defaultStyles} from 'react-json-view-lite';

import './JsonViewer.css';

interface IProps {
  args: object;
}

export const JsonViewer: FC<IProps> = ({args}) => {
  return <JsonView data={args} shouldExpandNode={() => false} style={defaultStyles} />;
};
